import { createContext, useState, useEffect } from 'react'
import axios from 'axios'

import { urlValue } from './url'
import { unfolder } from './CryptoMethods'
import { getCookie } from './CookiesMethod'
export const validContext = createContext(null)

export const ValidProvider = ({ children }) => {
  const [isValid, setIsValid] = useState(false)
  const [isInValidation, setIsInValidation] = useState(false)
  const validatedUser = async () => {
    let token = localStorage.getItem('hashUser') != null
      ? unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      : undefined;
  
    let id = localStorage.getItem('hashUser') != null
      ? unfolder(localStorage.getItem('hashUser'), 'IANestingKey').id
      : undefined;

    let iduser = localStorage.getItem('hashInfo') != null
      ? unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
      : undefined;

    const restTokenCk = await axios.get(`${urlValue}/getcoockies/hashUser`,{withCredentials: true});
     
     let idck = "";
     if(restTokenCk.data){ 
      idck = restTokenCk.data.ck;
     }
    

    // if (iduser?.toString() !== idck?.toString() ) {
    //   localStorage.clear()
    //   setIsValid(false)
    // } else {

      if (id == undefined || token == undefined) {
        localStorage.clear()
        setIsValid(false)
      } else if (isInValidation == true || isValid == false) {
        axios({
          method: 'get',
          url: `${urlValue}/studio/user/${id}`,
          headers: {
            'access-token': token,
          },
        })
          .then(function (response) {
            setIsValid(true)
          })
          .catch(function (error) {
            localStorage.clear()
            setIsValid(false)
          })
      }
    // }
    setIsInValidation(false)
  }
  useEffect(() => {
    validatedUser();
  }, [isInValidation])

  return (
    <validContext.Provider
      value={[isValid, setIsValid, isInValidation, setIsInValidation]}
    >
      {children}
    </validContext.Provider>
  )
}
